export default __webpack_public_path__ + "ae68bcec47e1bf145a0489d5c391d1a3.svg";